// 控制弹窗出现时，页面是否能滚动
export const bodyScroll = {
    forbidden() {
        document.body.classList.add('overflowHidden');
    },
    can() {
        document.body.classList.remove('overflowHidden');
    },
};
export const colors = ['#0080FF', '#08DBA2', '#4B4BCE', '#EF455B', '#FE8E20', '#FFDD01', '#95FA74', '#07C6F3', '#452379'];
